/**
 * Fires a GA4 page view on every react-router location change.
 *
 * Placed inside layouts (CustomerLayout for authenticated pages,
 * inlined on standalone auth pages) so the effect has access to
 * useLocation. Renders no visible UI.
 *
 * When analytics is not initialised (dev, staging, or missing env
 * var) trackPageView() is a no-op, so this component can be included
 * unconditionally.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../services/analytics';

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
